import { AuthEnums } from "models/enums";
import { WintSuperkollAPIModel as ApiModel } from "wint-api-client/dist/types";
//#endregion
import { ApiClientInstance } from "utils/helpers";

/**
 * @deprecated This service is deprecated. Use useProfileService hook instead.
 *
 * @see useProfileService - The replacement hook
 * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
 */
const ProfileService = {
  getProfileImage: (profileId: number): Promise<ApiModel.ProfileImage> => {
    return ApiClientInstance(AuthEnums.AuthType.User)
      .ProfileImagesClient.Get(profileId)
      .then((res) => res.data);
  },
};

export default ProfileService;
